module.exports = "/_next/static/images/alexa-93fbf63471fe35219e4916ae346d5295.png";